var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exchange-detail detail-padding" }, [
    _c("div", { staticClass: "spaceBetween flexEnd" }, [
      _c(
        "div",
        {
          staticClass: "detail-title-1",
          staticStyle: { "font-size": "0.48rem" },
        },
        [
          _c(
            "p",
            {
              staticClass: "td-word-sm",
              staticStyle: { "font-size": "0.2rem" },
            },
            [_vm._v("Deposit balance")]
          ),
          _vm._v(" "),
          _c("big-number", {
            attrs: { number: _vm.balance },
            on: {
              "update:number": function ($event) {
                _vm.balance = $event
              },
            },
          }),
          _c(
            "span",
            {
              staticClass: "td-word-sm",
              staticStyle: { "font-size": "0.2rem" },
            },
            [_vm._v(" TCash")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-form" },
        [
          _c("search-select", {
            attrs: { label: "Type", options: _vm.typeOptions },
            on: {
              valChange: function ($event) {
                return _vm.valChange($event, "type")
              },
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "common-card" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "common-table",
            attrs: { data: _vm.tableList },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "timestamp", label: "Date", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.moment(row.timestamp).format("YYYY.MM.DD")
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "type", label: "Type", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "spaceLeft" }, [
                        row.type == "1"
                          ? _c("img", {
                              staticClass: "td-type-img",
                              attrs: {
                                src: require("@/assets/image/exchange/huan.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        row.type == "2"
                          ? _c("img", {
                              staticClass: "td-type-img",
                              attrs: {
                                src: require("@/assets/image/exchange/huigou.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        row.type == "3"
                          ? _c("img", {
                              staticClass: "td-type-img",
                              attrs: {
                                src: require("@/assets/image/exchange/lixi.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.getTypeLabel(row.type)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "amount",
                label: "TCash Quantity",
                align: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", [_vm._v(_vm._s(row.type == "2" ? "-" : "+"))]),
                      _vm._v(" "),
                      _c("big-number", {
                        attrs: { number: row.amount },
                        on: {
                          "update:number": function ($event) {
                            return _vm.$set(row, "amount", $event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "td-word-sm" }, [
                        _vm._v("TCash"),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("pagination", {
          attrs: {
            total: _vm.queryParams.total,
            page: _vm.queryParams.page,
            limit: _vm.queryParams.pageSize,
          },
          on: {
            "update:total": function ($event) {
              return _vm.$set(_vm.queryParams, "total", $event)
            },
            "update:page": function ($event) {
              return _vm.$set(_vm.queryParams, "page", $event)
            },
            "update:limit": function ($event) {
              return _vm.$set(_vm.queryParams, "pageSize", $event)
            },
            pagination: function ($event) {
              return _vm.getList()
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }